// Favorites management using LocalStorage
const STORAGE_KEY = 'aiseki_favorites';

function getFavorites() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
}

function saveFavorites(ids) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
}

function toggleFavorite(branchId) {
  const favorites = getFavorites();
  const id = Number(branchId);
  const index = favorites.indexOf(id);
  if (index === -1) {
    favorites.push(id);
  } else {
    favorites.splice(index, 1);
  }
  saveFavorites(favorites);
  return favorites.includes(id);
}

function isFavorite(branchId) {
  return getFavorites().includes(Number(branchId));
}

function initFavoriteStars() {
  document.querySelectorAll('.js-favorite-star').forEach(star => {
    const branchId = star.dataset.branchId;
    if (isFavorite(branchId)) {
      star.classList.add('is-active');
    }
    star.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isNowFavorite = toggleFavorite(branchId);
      star.classList.toggle('is-active', isNowFavorite);
      // GA4 計測（GTM 経由）。遷移を伴わないため beacon 不要。
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          // branchId は delegated 計測(data 属性)と揃えて文字列で送る（GA4/BQ での型統一）
          event: 'favorite_toggle',
          branchId: String(branchId),
          state: isNowFavorite ? 'add' : 'remove'
        });
      } catch (e) { /* no-op: 計測失敗で操作を止めない */ }
    });
  });
}

function initFavoritesFilter() {
  const toggle = document.getElementById('favorites-filter-toggle');
  if (!toggle) return;

  toggle.addEventListener('click', () => {
    toggle.classList.toggle('is-active');
    const showOnlyFavorites = toggle.classList.contains('is-active');
    const favorites = getFavorites();

    document.querySelectorAll('.store-box[data-branch-id]').forEach(box => {
      if (showOnlyFavorites && !favorites.includes(Number(box.dataset.branchId))) {
        box.style.display = 'none';
      } else {
        box.style.display = '';
      }
    });

    // Also hide empty location sections
    document.querySelectorAll('.location-title-wrapper').forEach(wrapper => {
      const nextSibling = wrapper.nextElementSibling;
      if (nextSibling && nextSibling.classList.contains('store-box-wrapper')) {
        const visibleBoxes = nextSibling.querySelectorAll('.store-box[data-branch-id]:not([style*="display: none"])');
        wrapper.style.display = visibleBoxes.length === 0 && showOnlyFavorites ? 'none' : '';
        nextSibling.style.display = visibleBoxes.length === 0 && showOnlyFavorites ? 'none' : '';
      }
    });
  });
}

// F3: お気に入り店の「いまの混雑」モジュール。トップの #favorites-status コンテナがある場合のみ動作。
// localStorage の branch_id を favorites_status に問い合わせ、現在状況カードを描画する（0件・失敗時は何も出さない）。
function buildFavoriteCard(store) {
  const card = document.createElement('a');
  card.className = 'favorites-status__card';
  // id は数値化してから組み立て（XSS / パス汚染防止）
  card.href = `/stores/${Number(store.id)}`;
  card.setAttribute('data-gtm-event', 'favorites_status_click');
  card.setAttribute('data-gtm-branch-id', String(Number(store.id)));

  const name = document.createElement('span');
  name.className = 'favorites-status__name';
  name.textContent = store.name;
  card.appendChild(name);

  // 営業時間外・取得停止中は混雑/女性比の代わりに状態ラベルを出す（サーバ側で
  // congestion_label / women_label は null になる。凍結値を「いまの混雑」として出さないため）。
  if (store.status_label) {
    const status = document.createElement('span');
    status.className = 'favorites-status__state';
    status.textContent = store.status_label;
    card.appendChild(status);
  }
  if (store.congestion_label) {
    const congestion = document.createElement('span');
    congestion.className = 'favorites-status__congestion';
    congestion.textContent = store.congestion_label;
    card.appendChild(congestion);
  }
  if (store.women_label) {
    const women = document.createElement('span');
    women.className = 'favorites-status__women';
    women.textContent = store.women_label;
    card.appendChild(women);
  }
  // ブランド固定の入店条件（THE SINGLE のアプリ会員登録必須など）。textContent なので安全。
  if (store.entry_notice_label) {
    const entryNotice = document.createElement('span');
    entryNotice.className = 'entry-notice-badge';
    entryNotice.setAttribute('data-entry-notice-badge', '');
    entryNotice.textContent = store.entry_notice_label;
    card.appendChild(entryNotice);
  }
  return card;
}

function initFavoritesStatus() {
  const container = document.getElementById('favorites-status');
  if (!container) return;

  const favorites = getFavorites();
  if (!favorites.length) return;

  const ids = favorites.map(Number).filter(Number.isInteger).join(',');
  if (!ids) return;

  fetch(`/stores/favorites_status?ids=${ids}`, { headers: { Accept: 'application/json' } })
    .then(res => (res.ok ? res.json() : Promise.reject(new Error('bad status'))))
    .then(data => {
      const stores = (data && data.stores) || [];
      if (!stores.length) return;

      const heading = document.createElement('h2');
      heading.className = 'favorites-status__title';
      heading.textContent = 'お気に入りのいまの混雑';

      const list = document.createElement('div');
      list.className = 'favorites-status__list';
      stores.forEach(store => list.appendChild(buildFavoriteCard(store)));

      container.appendChild(heading);
      container.appendChild(list);
      container.hidden = false;

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'favorites_module_shown', count: stores.length });
      } catch (e) { /* no-op */ }
    })
    .catch(() => { /* 失敗時は何も出さない（既存フィルタ機能は不変） */ });
}

document.addEventListener('DOMContentLoaded', () => {
  initFavoriteStars();
  initFavoritesFilter();
  initFavoritesStatus();
});

// Export for map page use
window.aisekiFavorites = { getFavorites, isFavorite };
